export const PURCHASE_TYPE_SUBSCRIPTION = 'subscription'
export const PURCHASE_TYPE_ONETIME = 'one-time'
